import { call, put, takeLatest } from "redux-saga/effects";
import { actions } from "./slice";
import * as API from "../../../../services/apis";

function* handleFetchRegretData(action) {
  const { filtersString } = action.payload || {};
 
  try {
    const response = yield call(API.fetchRegretDashboardData, {
      filtersString,
    });
    const apiData = response.data?.data || response.data;
  
    yield put(actions.fetchRegretDataSuccess({ data: apiData }));
  } catch (error) {
    console.error('❌ API Error:', error);
    const errorMessage = error?.response?.data?.message || error?.message || 'Unknown error occurred';
    yield put(actions.fetchRegretDataFailure(errorMessage));
  }
}

export function* regretDashboardSaga() {
  yield takeLatest(actions.fetchRegretData.type, handleFetchRegretData);
}